import React, { FC, memo, useMemo } from 'react';
import Cascader from '../cascader';
import SystemTag from '../system-tag';

const FIELD_NAMES = { value: 'id', label: 'name' };

type TTagTreeData = any[];

interface TagSelectProps {
  alwaysOpen?: true;
  className?: string;
  data: TTagTreeData;
  multiple?: boolean;
  value?: number[];
  onChange?: (value: number[]) => void;
}

const TagSelect: FC<TagSelectProps> = props => {
  const { alwaysOpen, className, data, multiple, value, onChange } = props;
  const treeData: any = useMemo(() => data.map(item => ({ ...item, uncheckable: true })), [data]);

  const selector = (
    <Cascader
      alwaysOpen={alwaysOpen}
      className={className}
      showCheckedStrategy={Cascader.SHOW_CHILD}
      placeholder='请选择'
      fieldNames={FIELD_NAMES}
      multiple={multiple}
      treeData={treeData}
      itemWidth={150}
      value={value}
      onChange={onChange as any}
      renderNode={(label, v, data) => <SystemTag data={data as any} />}
    />
  );

  return alwaysOpen ? <div style={{ width: 300 }}>{selector}</div> : selector;
};
export default memo(TagSelect);
